import React, { useState } from "react";
import { Box, Typography, Table, TableCell, TableHead, TableBody, TableRow, TableContainer, Paper, Button, Grid, Tooltip, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomButton from "components/Button";
import { FaPlus } from "react-icons/fa6";
import { GrView } from "react-icons/gr";

const tableData = [
    {
        id: 1,
        dprdate: "30-10-2025",
        submissiondate: "30-10-2025",
        activity: "3",
        submittedby: "Satish",
    },
    {
        id: 2,
        dprdate: "31-10-2025",
        submissiondate: "31-10-2025",
        activity: "6",
        submittedby: "Samrat",
    },
    {
        id: 3,
        dprdate: "01-11-2025",
        submissiondate: "01-11-2025",
        activity: "9",
        submittedby: "Shanti",
    },
    {
        id: 4,
        dprdate: "02-11-2025",
        submissiondate: "02-11-2025",
        activity: "5",
        submittedby: "Ashok",
    },
    {
        id: 5,
        dprdate: "03-11-2025",
        submissiondate: "03-11-2025",
        activity: "7",
        submittedby: "Sanjeev",
    },
];

function PhysicalProgress() {

    const navigate = useNavigate();

    return (
        <>
            <Grid container>
                <Grid size={12}
                    sx={{
                        borderBottom: "1px solid #ECECEC",
                        backgroundColor: "#F6F8F9",
                        justifyContent: "space-between",
                        display: "flex",
                        px: 2,
                        py: 4,
                    }}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: "24px", sm: "32px", md: "36px" },
                                lineHeight: "48px",
                                color: "#252C32",
                                fontFamily: "Outfit, sans-serif",
                            }}>
                            DPR
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "flex-start", sm: "flex-end" },
                            mt: { xs: 1, sm: 0 },
                            mb: 2,
                        }}>
                        <CustomButton
                            label="Add DPR"
                            startIcon={<FaPlus />}
                            color="primary"
                            onClick={() => navigate("/projects/7d9e0306-81f4-4cdc-8752-de441b460997/dpr/physical-progress/add-dpr")}
                            sx={{
                                backgroundColor: "#2563EB",
                                fontFamily: 'Outfit',
                                fontWeight: 500,
                                fontSize: '14px',
                                lineHeight: '100%',
                                letterSpacing: '0px',
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid size={12} sx={{ backgroundColor: "#fff" }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow >
                                    <TableCell>S. No.</TableCell>
                                    <TableCell>DPR Date</TableCell>
                                    <TableCell>Submission Date</TableCell>
                                    <TableCell>No. of Activities</TableCell>
                                    <TableCell>Submitted By</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.map((row, index) => (
                                    <TableRow
                                        key={row.id}
                                    >
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{row.dprdate}</TableCell>
                                        <TableCell>{row.submissiondate}</TableCell>
                                        <TableCell>{row.activity}</TableCell>
                                        <TableCell>{row.submittedby}</TableCell>
                                        <TableCell sx={{ cursor: "pointer" }}>
                                            <Tooltip title="View" arrow>
                                                <IconButton
                                                    onClick={() =>
                                                        navigate("/projects/10b9ff2d-8d78-44c4-96b4-26ba2cc35f13/dpr/physical-progress/view-dpr",
                                                            { state: { dprDate: row.dprdate } }
                                                        )
                                                    }
                                                >
                                                    <GrView size={15} />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </>
    );
}

export default PhysicalProgress;